import { pluralizeWithCount } from "@common/helpers/string";

export const getCreateTaskLabel = ({
    taskCount,
}: {
    taskCount: number;
}): string =>
    taskCount > 1
        ? `Create ${pluralizeWithCount("task", taskCount)}`
        : "Create task";
